import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.84692 13.061C9.94818 13.3047 10.0002 13.5661 10 13.83V20.5C10 20.5929 10.0259 20.6839 10.0747 20.7629C10.1235 20.8419 10.1933 20.9057 10.2764 20.9472C10.3594 20.9887 10.4524 21.0063 10.5449 20.998C10.6374 20.9896 10.7257 20.9557 10.8 20.9L13.2 19.1C13.4484 18.9137 13.65 18.6721 13.7889 18.3944C13.9277 18.1167 14 17.8105 14 17.5V13.83C13.9998 13.5661 14.0518 13.3047 14.1531 13.061C14.2543 12.8173 14.4028 12.5961 14.59 12.41L20.41 6.59C20.5972 6.40394 20.7457 6.18268 20.8469 5.93897C20.9482 5.69526 21.0002 5.43391 21 5.17V4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V5.17C2.99979 5.43391 3.05182 5.69526 3.15308 5.93897C3.25434 6.18268 3.40283 6.40394 3.59 6.59L9.41 12.41C9.59717 12.5961 9.74566 12.8173 9.84692 13.061Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgFilter = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgFilter;
